import { MetricsDataModel } from '../models/metrics/metrics-data.model';
import { MetricsService } from '../../services/metrics.service';
import { MetricsType } from '../models/metrics/metrics-type.enum';
import * as moment_ from 'moment';
import { DateFormat } from '../esp-datefield/models/date-formats';
import { isNullOrUndefined } from 'util';
import { FieldConfig } from '../../models/field-config';
import { CustomMetricsModel } from '../models/metrics/custom-metrics.model';
import { FieldType } from '../../models/field-type';
import { isArray } from '../../../core/utils/utils';

export class Metrics {
  private metric: MetricsDataModel;
  private _fieldConfig: FieldConfig;
  private _value: any;
  private _customMetrics: CustomMetricsModel;

  constructor(public metricsService: MetricsService) {

  }
  get metricName(): string {
    if (this._customMetrics) {
      return this._customMetrics.sectionKey;
    }
    return this._fieldConfig.fieldKey;
  }

  get metricType(): MetricsType {
    switch (this._fieldConfig.type) {
      case FieldType.Select:
        return MetricsType.SELECT;
      case FieldType.DateField:
        return MetricsType.DATEPICKER;
      case FieldType.TextArea:
      case FieldType.TextField:
        return MetricsType.TEXTFIELD;
      case FieldType.Radio:
        return MetricsType.RADIO;
      case FieldType.Checkbox:
        return MetricsType.CHECKBOX;
    }
    return MetricsType.COMPONENT;
  }

  get metricValue(): string | number {
    if (this._customMetrics) {
      return this.prepareCustomMetrics();
    } else {
      if (isArray(this._value)) { // value is an array
        return JSON.stringify({'items': this._value});
      } else if (typeof this._value === 'boolean') { // value is boolean
        return this._value.toString();
      } else if (moment_.isMoment(this._value)) { // value is a Moment object
        return moment_(this._value).format(DateFormat.YYYY_MM_DD_minus);
      }
      return this._value;
    }
  }

  initMetrics(fieldConfig: FieldConfig, customMetrics: CustomMetricsModel): void {
    this._fieldConfig = fieldConfig;
    this._customMetrics = customMetrics;

    this.initMetric();
  }

  openMetric(): void {
    this.metric.open();
  }

  changeMetric(value: any) {
    this._value = value;
    this.metric.change(this.metricValue);
  }

  closeMetric(): void {
    this.metric.close();
  }

  sendMetric(): void {
    this.metricsService.send(this.metric);
  }

  private initMetric() {
    if (isNullOrUndefined(this.metric)) {
      this.metric = new MetricsDataModel(this.metricName, this.metricType);
    }
  }

  private prepareCustomMetrics(): string {
    let json = {
      key: this._fieldConfig.fieldKey,
      value: this._value,
      count: this._customMetrics.count
    };
    return JSON.stringify(json);
  }

}
